<template>
  <v-data-table
    :headers="headers"
    :items="items"
    item-key="covgId"
    :loading="dataTableLoading"
    loading-text="Loading... Please wait"
    hide-default-footer
    disable-sort
  >
    <template v-slot:item.status="{ item }">
      <pt-chip :color="getColor(item.status)">
        {{ getStatusText(item) }}
      </pt-chip>
    </template>
    <template v-slot:item.assignedDate="{ value }">
      {{ value | formatDate("LL") }}
    </template>
    <template v-slot:item.completionDate="{ value }">
      {{ value | formatDate("LL") }}
    </template>
    <template v-slot:item.assignees="{ value }">
      <text-and-hovertext
        :text="value.join(', ')"
        class="assignees"
      ></text-and-hovertext>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        v-if="
          item.itemType === 'VendorReviewWorkflowItemBehavior' &&
            item.stepAction
        "
        depressed
        color="primary"
        :href="vendorReviewPath(item.id)"
      >
        {{ item.stepAction.label }}
      </v-btn>
      <v-btn
        v-else-if="item.stepAction"
        depressed
        color="primary"
        :to="{
          name: 'workflowStep',
          params: {
            covgId: covgId,
            itemId: item.id
          }
        }"
      >
        {{ item.stepAction.label }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { get } from "@/services/request";
import { workflowStepsAPI } from "@/services/api";
import PtChip from "@/components/providertrust/PtChip.vue";
import { formatDate } from "@/services/format";
import TextAndHovertext from "@/components/TextAndHovertext.vue";

export default {
  name: "WorkflowTable",
  components: { TextAndHovertext, PtChip },
  props: ["covgId"],
  data() {
    return {
      headers: [
        { text: "Item", value: "name" },
        { text: "Status", value: "status" },
        { text: "Assigned Date", value: "assignedDate" },
        { text: "Completion Date", value: "completionDate" },
        { text: "Assigned", value: "assignees" },
        { text: "Completed", value: "completer" },
        { text: "Actions", value: "actions", align: "end" }
      ],
      items: [],
      dataTableLoading: true,
      resolutionUIType: null
    };
  },
  created() {
    this.loadTableData();
  },
  filters: {
    formatDate
  },
  methods: {
    loadTableData() {
      this.dataTableLoading = true;
      get(workflowStepsAPI.getUrl({ covgId: this.covgId })).then(response => {
        if (response && response.data) {
          this.items = response.data;
        }
        this.dataTableLoading = false;
      });
    },
    getColor(status) {
      switch (status) {
        case "BLOCKED":
          return "colorSemanticStateRed200";
        case "PENDING":
        case "ACTIVE":
          return "colorSemanticStateYellow200";
        case "COMPLETE":
          return "colorSemanticStateGreen200";
        default:
          return "colorNeutralsNavy100";
      }
    },
    getStatusText(item) {
      if (item) {
        return item.status === "NON_APPLICABLE"
          ? "N/A"
          : item.status.toLowerCase();
      }
    },
    vendorReviewPath(itemId) {
      return "/client/manage/onboard?workflowItemId=" + itemId;
    }
  }
};
</script>

<style scoped lang="scss">
.assignees {
  max-width: 200px;
}
</style>
